module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/coffee@3x_921cf8.jpg";